import styles from './Wordmark.module.css';

export type WordmarkProps = {
  size?: number;
};

export function Wordmark({ size = 20 }: WordmarkProps) {
  return (
    <span className={styles['wordmark']} style={{ fontSize: size }}>
      MCGAMES
    </span>
  );
}
